import React, { useState } from 'react'
//import CustomTextField from '../../GlobalComponents/CustomComponant/CustomTextField'
import { Button, IconButton, InputAdornment, TextField } from '@mui/material'
//import CircularProgress from "@mui/material/CircularProgress";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

function ChangePassword() {

  const [showPassword, setShowPassword] = useState(false);
 // const [pageLoader, setPageLoader] = useState(false);
 
 
const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = () => {
    const newErrors = {};
  
    // console.log("old Password", currentPassword); 
    // console.log("new Password", newPassword);
    // console.log("confirm Password", confirmPassword);
  
    // Check if fields are empty
    // if (!currentPassword) {
    //   newErrors.currentPassword = "Current password is required";
    // }
  
    if (!newPassword) {
      newErrors.newPassword = "New password is required";
    }
  
    if (!confirmPassword) {
      newErrors.confirmPassword = "Confirm password is required";
    }
  
    // Password complexity checks (only if newPassword is not empty)
    if (newPassword) {
      if (newPassword.length < 8) {
        newErrors.newPassword = "Password must be at least 8 characters long";
      } else if (!/[A-Z]/.test(newPassword)) {
        newErrors.newPassword = "Password must contain at least one uppercase letter";
      } else if (!/[a-z]/.test(newPassword)) {
        newErrors.newPassword = "Password must contain at least one lowercase letter";
      } else if (!/[0-9]/.test(newPassword)) {
        newErrors.newPassword = "Password must contain at least one number";
      } else if (!/[!@#$%^&*]/.test(newPassword)) {
        newErrors.newPassword = "Password must contain at least one special character";
      } else if (newPassword === currentPassword) {
        newErrors.newPassword = "New password cannot be the same as the current password";
      }
    }
  
    // Confirm password checks
    if (confirmPassword) {
      if (confirmPassword !== newPassword) {
        newErrors.confirmPassword = "Passwords do not match";
      } else if (confirmPassword.length < 8) {
        newErrors.confirmPassword = "Confirm password must be at least 8 characters long";
      } else if (!/[A-Z]/.test(confirmPassword)) {
        newErrors.confirmPassword = "Confirm password must contain at least one uppercase letter";
      } else if (!/[a-z]/.test(confirmPassword)) {
        newErrors.confirmPassword = "Confirm password must contain at least one lowercase letter";
      } else if (!/[0-9]/.test(confirmPassword)) {
        newErrors.confirmPassword = "Confirm password must contain at least one number";
      } else if (!/[!@#$%^&*]/.test(confirmPassword)) {
        newErrors.confirmPassword = "Confirm password must contain at least one special character";
      } else if (confirmPassword === currentPassword) {
        newErrors.confirmPassword = "Confirm password cannot be the same as the current password";
      }
    }
  
    // If there are any errors, set them and stop submission
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      console.log("Password Not Changed Due to Error!",Object.values(newErrors));
      return;
    }
  
    // ✅ Form passes validation
    setErrors({}); 
    console.log("Password Changed!",{newPassword});
    // continue with form submission logic...
  };
  
  const handleCancel = () => {
    // Handle the cancel action here
    console.log("Form cancelled!");
  };


  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
 


return (
    <div> 
      
      
    
      
      
      <div className="windows-header">
    <h2>Change Password</h2>
  </div>
   <div className="content">
  {/*<div className="container">
              <div className="input-group">
              <TextField
            fullWidth
            type="password"
            label="Current Password"
            variant="outlined"
           value={currentPassword}
           onChange={(e) => setCurrentPassword(e.target.value)}
           error={!!errors.currentPassword}
           helperText={errors.currentPassword}
          />
		  </div>    

     
      </div> */}
  
            <div className="container">
            <div className="input-group">
                <TextField
                  fullWidth
                  type={showPassword ? "text" : "password"}
                  label="New Password"
                  variant="outlined"
                 value={newPassword}
                 onChange={(e) => setNewPassword(e.target.value)}
                 error={!!errors.newPassword}
                 helperText={errors.newPassword}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowPassword}
                          edge="end"
                          aria-label="toggle password visibility"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
             
                       

              <div className="input-group">
                <TextField
                  fullWidth
                  type={showPassword ? "text" : "password"}
                  label="Confirm New Password"
                  variant="outlined"
                 value={confirmPassword}
                 onChange={(e) => setConfirmPassword(e.target.value)}
                 error={!!errors.confirmPassword}
                 helperText={errors.confirmPassword}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowPassword}
                          edge="end"
                          aria-label="toggle password visibility"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>




            <div className="container"> 
         <div className="input-group " >   
       
    
        </div>
          
         
          
          </div>





           
          


<div>
<h4>Password Complexity Requirements:</h4>

<ul class="custom-list">
  <li>Password must be at least 8 characters long.</li>
  <li>Contain at least one uppercase letter.</li>
  <li>Contain at least one lowercase letter.</li>
  <li>Contain at least one number.</li>
  <li>Contain at least one special character.</li>
</ul>

</div>

<div >
          <Button
                className="button button1"
                type="button" // Updated type attribute to "button"
               onClick={handleSubmit}
                title="Click for Change Password"
                fullWidth
              >
                Change Password
              </Button>
                  </div>
        </div>
  
  </div>
  )
}

export default ChangePassword